(() => {
  var mmS = window.mmS || function (k, d) { return d; }, mmF = window.mmF || function (k, d, o) { return String(d).replace(/\{(\w+)\}/g, function (x, n) { return o && o[n] != null ? o[n] : x; }); }, mmP = window.mmP || function (p) { return p; }, mmL = window.mmL || function (t) { return t; };
  const grid = document.querySelector("[data-plp-grid]");
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll(".plp-card"));
  const colorBox = document.querySelector("[data-plp-colors]");
  const styleBox = document.querySelector("[data-plp-styles]");
  const minInput = document.querySelector("[data-price-min]");
  const maxInput = document.querySelector("[data-price-max]");
  const high = document.querySelector("[data-plp-high]");
  const skc = grid.dataset.mode === "skc";
  let family = "all";
  let style = "all";

  const fills = {
    Multicolor: "conic-gradient(#e7a3b5, #1c1614, #e8d48a, #3d6fbf, #3d6b4f, #f7f4ef)",
    Black: "#1c1614",
    White: "#f7f4ef",
    Nude: "#e7cbb8",
    Brown: "#8a5a3c",
    Pink: "#e7a3b5",
    Red: "#9a3040",
    Orange: "#d9772e",
    Purple: "#b7a4d6",
    Blue: "#2f6f86",
    Green: "#3d6b4f",
    Gray: "#9a938c",
    Yellow: "#e8d48a",
    Leopard: "conic-gradient(#e7c2a4, #1c1614, #c47a8a, #8a6242)",
    Light: "#f0d7c4",
    Tan: "#d4a57a",
    Bronze: "#a66b45",
    Cocoa: "#6b3f2a",
  };

  const familyOrder = ["Black", "White", "Nude", "Brown", "Pink", "Red", "Orange", "Yellow", "Green", "Blue", "Purple", "Gray", "Leopard", "Multicolor"];
  const skinToneOrder = ["Light", "Tan", "Bronze", "Cocoa"];
  const collectionHandle = (grid.dataset.collection || "").toLowerCase();
  const exactSkc = collectionHandle === "tights";

  // Solid colour names -> filter family. Exact names first, then the last colour word ("Rose Red" -> Red).
  const solids = {
    black: "Black", jet: "Black", "jet black": "Black", "signal black": "Black", "triangle black": "Black",
    white: "White", ivory: "White", cream: "White", "off white": "White", "cloud white": "White", "a-white": "White",
    nude: "Nude", beige: "Nude", sand: "Nude", skin: "Nude", "light skin": "Nude", khaki: "Nude", apricot: "Nude",
    camel: "Nude", "light camel": "Nude", stone: "Nude", light: "Nude", tan: "Nude",
    brown: "Brown", coffee: "Brown", cocoa: "Brown", chocolate: "Brown", mocha: "Brown", taupe: "Brown",
    caramel: "Brown", bronze: "Brown", ochre: "Brown",
    pink: "Pink", "barbie pink": "Pink", "baby pink": "Pink", "hot pink": "Pink", "light pink": "Pink",
    rose: "Pink", "dusty rose": "Pink", blush: "Pink", mauve: "Pink", magenta: "Pink",
    red: "Red", wine: "Red", burgundy: "Red",
    orange: "Orange", tangerine: "Orange",
    yellow: "Yellow", "light yellow": "Yellow", butter: "Yellow",
    green: "Green", emerald: "Green", sage: "Green", mint: "Green", matcha: "Green", jade: "Green",
    forest: "Green", olive: "Green", lime: "Green",
    blue: "Blue", navy: "Blue", teal: "Blue", turquoise: "Blue", midnight: "Blue",
    purple: "Purple", lilac: "Purple", lavender: "Purple", violet: "Purple", "purple fig": "Purple",
    gray: "Gray", grey: "Gray", charcoal: "Gray", slate: "Gray", "gray purple": "Gray",
  };
  // Mixed packs / prints whose names carry no pattern keyword.
  const multiNames = ["dark palette", "macaron", "berry bloom", "muted mist", "neo checker"];
  // Packs of one tone family.
  const overrides = { "6-pack nude mix": "Nude" };
  const patternWords = /(print|floral|flower|stripe|plaid|check|gingham|polka|\bdots?\b|zebra|tie[- ]?dye|camo|patchwork|colou?r[- ]?block|contrast|heart|\bcats?\b|halloween|christmas|gingerbread|pumpkin|\bstars?\b|\bmoon\b|butterfly|paisley|graphic|pattern|multi|\bmix\b|assorted|rainbow|ombre)/;

  function solidOf(name) {
    if (solids[name]) return solids[name];
    const words = name.split(" ");
    for (let i = words.length - 1; i >= 0; i -= 1) {
      if (solids[words[i]]) return solids[words[i]];
    }
    return "";
  }

  function familyOf(color) {
    const raw = (color || "").trim();
    const name = raw.toLowerCase().replace(/\s+/g, " ");
    if (!name) return "";
    if (/leopard|cheetah/.test(name)) return "Leopard";
    if (overrides[name]) return overrides[name];
    if (multiNames.includes(name) || patternWords.test(name)) return "Multicolor";
    const core = name
      .replace(/\(\s*\d+\s*-?\s*pack\s*\)/g, " ")
      .replace(/\b\d+\s*-?\s*pack\b/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (!core || /^(set \d+|new)$/.test(core)) return "Multicolor";
    const parts = core.split(/\s*(?:\+|&|\/|,|\band\b)\s*/).map((part) => part.replace(/^\d+\s+/, "").trim()).filter(Boolean);
    const groups = parts.map(solidOf);
    if (groups.some((group) => !group)) return parts.length > 1 ? "Multicolor" : raw;
    const unique = Array.from(new Set(groups));
    return unique.length === 1 ? unique[0] : "Multicolor";
  }

  const mmCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
  const mmMoney = new Intl.NumberFormat("en-US", { style: "currency", currency: mmCurrency });
  function money(cents) {
    return mmMoney.format((cents || 0) / 100);
  }

  function paint(card, swatch) {
    const img = card.querySelector("[data-plp-img]");
    const link = card.querySelector("[data-plp-link]");
    const name = card.querySelector("[data-plp-name]");
    const price = card.querySelector("[data-plp-price]");
    const compare = card.querySelector("[data-plp-compare]");
    if (img && swatch.dataset.src) {
      img.src = swatch.dataset.src;
      img.removeAttribute("srcset");
    }
    if (link) link.href = swatch.dataset.href;
    if (name) name.href = swatch.dataset.href;
    if (price && swatch.dataset.money) price.textContent = swatch.dataset.money;
    if (compare) {
      if (swatch.dataset.compare) {
        compare.hidden = false;
        compare.textContent = swatch.dataset.compare;
      } else {
        compare.hidden = true;
        compare.textContent = "";
      }
    }
    card.querySelectorAll(".plp-swatch").forEach((el) => el.classList.toggle("is-active", el === swatch));
  }

  function chip(box, value, label, fill) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "plp-chip";
    button.dataset.family = value;
    if (fill) {
      const dot = document.createElement("i");
      dot.style.background = fill;
      button.append(dot);
    }
    button.append(document.createTextNode(mmS("chip_" + String(label).toLowerCase().replace(/[^a-z0-9]+/g, "_"), label)));
    button.addEventListener("click", () => {
      if (box === colorBox) family = value;
      else style = value;
      apply();
    });
    box.append(button);
  }

  cards.forEach((card) => {
    card.querySelectorAll(".plp-swatch").forEach((swatch) => {
      swatch.addEventListener("click", () => paint(card, swatch));
    });
    const more = card.querySelector("[data-plp-more]");
    more?.addEventListener("click", () => {
      card.querySelector(".plp-swatches")?.classList.add("is-open");
      more.remove();
    });
  });

  if (colorBox) {
    chip(colorBox, "all", "All");
    if (skc) {
      if (exactSkc) {
        const present = new Set(cards.map((card) => card.dataset.skc || "").filter(Boolean));
        const ordered = skinToneOrder.filter((name) => present.has(name));
        const extras = Array.from(present).filter((name) => !skinToneOrder.includes(name)).sort();
        ordered.concat(extras).forEach((name) => {
          chip(colorBox, name, name, fills[name] || "#cfc6be");
        });
      } else {
        const present = new Set(cards.map((card) => familyOf(card.dataset.skc || "")).filter(Boolean));
        const ordered = familyOrder.filter((name) => present.has(name));
        const extras = Array.from(present).filter((name) => !familyOrder.includes(name)).sort();
        ordered.concat(extras).forEach((name) => {
          chip(colorBox, name, name, fills[name] || "#cfc6be");
        });
      }
    } else {
      const present = new Set();
      cards.forEach((card) => {
        const names = new Set();
        card.querySelectorAll(".plp-swatch").forEach((swatch) => {
          const name = familyOf(swatch.dataset.color || "");
          if (name) names.add(name);
        });
        card.dataset.families = Array.from(names).join("|");
        names.forEach((name) => present.add(name));
      });
      const ordered = familyOrder.filter((name) => present.has(name));
      const extras = Array.from(present).filter((name) => !familyOrder.includes(name)).sort();
      ordered.concat(extras).forEach((name) => {
        chip(colorBox, name, name, fills[name] || "#cfc6be");
      });
    }
  }

  if (styleBox) {
    chip(styleBox, "all", "All");
    chip(styleBox, "seamless", "Seamless");
    chip(styleBox, "jelly", "Jelly Bra");
    chip(styleBox, "lace-up", "Lace-Up");
  }

  const prices = cards.map((card) => Number(card.dataset.price || 0));
  const highest = prices.length ? Math.max(...prices) : 0;
  if (high) high.textContent = money(highest);
  if (maxInput) maxInput.placeholder = (highest / 100).toFixed(2);

  function colorOk(card) {
    if (family === "all") return true;
    if (skc) {
      const color = card.dataset.skc || "";
      if (exactSkc) return color === family;
      return familyOf(color) === family;
    }
    return (card.dataset.families || "").split("|").includes(family);
  }

  function apply() {
    const min = minInput && minInput.value !== "" ? Math.round(Number(minInput.value) * 100) : 0;
    const max = maxInput && maxInput.value !== "" ? Math.round(Number(maxInput.value) * 100) : Infinity;
    cards.forEach((card) => {
      const cents = Number(card.dataset.price || 0);
      const okStyle = style === "all" || (card.dataset.styles || "").split("|").includes(style);
      const ok = colorOk(card) && okStyle && cents >= min && cents <= max;
      card.hidden = !ok;
      if (!skc && ok && family !== "all") {
        const swatch = Array.from(card.querySelectorAll(".plp-swatch")).find((el) => familyOf(el.dataset.color || "") === family);
        if (swatch) paint(card, swatch);
      }
    });
    document.querySelectorAll("[data-plp-colors] .plp-chip, [data-plp-styles] .plp-chip").forEach((button) => {
      const box = button.closest("[data-plp-colors]") ? family : style;
      button.classList.toggle("is-active", button.dataset.family === box);
    });
  }

  minInput?.addEventListener("input", apply);
  maxInput?.addEventListener("input", apply);
  document.querySelector("[data-price-clear]")?.addEventListener("click", () => {
    if (minInput) minInput.value = "";
    if (maxInput) maxInput.value = "";
    apply();
  });
})();
